/**
 * Notification preferences, kept beside the rest of the app's local state.
 *
 * Quiet hours live here and on the Worker: here so the settings screen can
 * show them without a round trip, there because the Worker is what decides
 * whether a send happens while the phone is asleep.
 */
import { META_STORE, withStore } from "@/store/db";

const SETTINGS_KEY = "push-settings";

export interface PushSettings {
  quietFrom: number;
  quietTo: number;
  /** Shows that never notify, by Simkl id. */
  muted: number[];
}

export const DEFAULT_SETTINGS: PushSettings = { quietFrom: 23, quietTo: 8, muted: [] };

export async function readSettings(): Promise<PushSettings> {
  try {
    const [value] = await withStore<PushSettings | undefined>(
      META_STORE,
      "readonly",
      (store) => store.get(SETTINGS_KEY) as IDBRequest<PushSettings | undefined>,
    );
    return value ?? DEFAULT_SETTINGS;
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export async function writeSettings(settings: PushSettings): Promise<void> {
  await withStore(META_STORE, "readwrite", (store) => store.put(settings, SETTINGS_KEY));
}
